import { useQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import { DevicePreviewPageDocument } from '../queries/preview.generated';
import { FullPreview, Layout } from './components';

export const DevicePreview = () => {
  const params = useParams<{ deviceId: string }>();
  const deviceId = Number(params.deviceId);

  const { data, loading } = useQuery(DevicePreviewPageDocument, {
    variables: { deviceId },
  });

  const device = data?.device;

  return (
    <Layout>
      <LoadingPane in={loading && !data} size={40} thickness={4}>
        <Grid container>
          <Grid item xs={12}>
            {device && <FullPreview device={device} />}
          </Grid>
        </Grid>
      </LoadingPane>
    </Layout>
  );
};
